import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Plays a one-time organic "paint splash" fill animation when the element
 * first scrolls into view, then stays in its filled state.
 */
class SplashFill extends Component {
  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    super.connectedCallback();

    if (prefersReducedMotion()) {
      this.dataset.active = '';
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          this.dataset.active = '';
          this.#observer?.disconnect();
          this.#observer = null;
        }
      },
      { threshold: 0.1 }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('splash-fill')) {
  customElements.define('splash-fill', SplashFill);
}
